import { render, staticRenderFns } from "./DxBatchesBinsTable.vue?vue&type=template&id=6a8b0d45&"
import script from "./DxBatchesBinsTable.vue?vue&type=script&lang=js&"
export * from "./DxBatchesBinsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports